<template>
  <div class="flex items-center">
    <div
      v-for="(option, index) in optionsList"
      :key="index"
      class="flex items-center gap-2"
    >
      <input
        :id="(name ?? 'radio') + '_' + index"
        v-model="modelValue"
        type="radio"
        :value="option.value"
        :name="name"
        class="peer hidden"
        :data-testid="'input_' + option.name"
      />
      <label
        :for="(name ?? 'radio') + '_' + index"
        class="relative h-6 w-6 cursor-pointer rounded-full border-2 border-primary-2 peer-checked:before:absolute peer-checked:before:inset-1 peer-checked:before:block peer-checked:before:rounded-full peer-checked:before:bg-primary-2"
        :data-testid="'radioButton_' + option.name"
      ></label>
      <label
        :for="(name ?? 'radio') + '_' + index"
        class="flex cursor-pointer items-center gap-1.5 py-3 pr-3 text-lg"
        :data-testid="'label_' + option.name"
      >
        <em v-if="option.icon" class="mdi" :class="option.icon" />
        {{ option.name }}
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineModel } from 'vue';

const props = defineProps<{
  optionsList: {
    name: string;
    value: string | boolean;
    icon?: string;
  }[];
  name?: string;
}>();

const modelValue = defineModel<string | boolean | null>();
</script>

<style scoped></style>
